import { apiConstructor as api } from '@/api/apiConstructor';
import { AxiosResponse } from 'axios';
import { Build } from '@/types/build';

export async function getBuild(id: string): Promise<any> {
  try {
    const response: AxiosResponse = await api.get(`builds/${id}`);
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function getBuilds(): Promise<any> {
  try {
    const response: AxiosResponse = await api.get('builds');
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function saveBuild(build: Build): Promise<Build> {
  const url: string = build.id === null ? 'builds' : `builds/${build.id}`;

  try {
    const response: AxiosResponse =
      build.id === null
        ? await api.post(url, { ...build })
        : await api.put(url, { ...build });
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function deleteBuild(build: Build): Promise<Build> {
  try {
    const response: AxiosResponse = await api.delete(`builds/${build.id}`);
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}
